export enum EnumAutoBidRate {
  'Low' = 1,
  'Medium' = 2,
  'High' = 3,
}
